import { useCallback, useState } from "react";
import { MENU_SCREEN } from "../menu.types";

export const useMenuNavigation = (initialScreen: MENU_SCREEN) => {
  const [activeScreen, setActiveScreen] = useState<MENU_SCREEN>(initialScreen);
  const [screenHistory, setScreenHistory] = useState<MENU_SCREEN[]>([]);

  // previousScreen = zadnji ekran u historiji
  const previousScreen = screenHistory[screenHistory.length - 1];

  const changeScreen = useCallback(
    (screen: MENU_SCREEN) => {
      setScreenHistory((prev) => [...prev, activeScreen]); // dodaj trenutni na historiju
      setActiveScreen(screen);
    },
    [activeScreen],
  );

  const back = useCallback(() => {
    setScreenHistory((prev) => {
      if (prev.length === 0) return prev;
      const newHistory = [...prev];
      const lastScreen = newHistory.pop(); // uzmi zadnji ekran
      if (lastScreen) setActiveScreen(lastScreen); // postavi ga kao active
      return newHistory;
    });
  }, []);

  return {
    activeScreen,
    previousScreen,
    changeScreen,
    back,
  };
};
